module.exports = __webpack_public_path__ + "media/application/images/icons/cross_chunky-83f83bcf6c81061e7e17429a03307644.svg";